
<div class="container-fluid">
  <mat-divider class="mb-4"></mat-divider>
    <form [formGroup]="form" class="row">

      <div class="form-group col-md-3">
        <mat-form-field class="w-100 disabled"  color="primary" appearance="outline">
          <mat-label>RUT</mat-label>
          <input matInput placeholder="RUT" formControlName="rut" readonly>
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" color="primary" appearance="outline">
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="nombre" [disabled]="true">
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" color="primary" appearance="outline">
          <mat-label>Apellido Paterno</mat-label>
          <input matInput placeholder="Apellido Paterno" formControlName="apellidoPaterno">
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" color="primary" appearance="outline">
          <mat-label>Apellido Materno</mat-label>
          <input matInput placeholder="Apellido Materno" formControlName="apellidoMaterno">
        </mat-form-field>
      </div>

      <div class="form-group col-md-3">
        <mat-form-field class="w-100" color="primary" appearance="outline">
          <mat-label>Fecha de Nacimiento</mat-label>
          <input matInput formControlName="fechaNacimiento" [matDatepicker]="picker" placeholder="Ingrese MM-DD-AAAA" [max]="hoy">
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Celular</mat-label>
          <input matInput placeholder="Ingrese 8 dígitos" formControlName="celular" (input)="onPhoneInput()">
        </mat-form-field>
      </div>

      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Nacionalidad</mat-label>
          <mat-select placeholder="Nacionalidad" formControlName="tipoNacionalidad" (valueChange)="tipoNacionalidadChange($event)">
            <mat-option *ngFor="let tipo of getTipoNacionalidadKeys()" [value]="tipo">{{ tipoNacionalidad[tipo]}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline" id="paisNacionalidad">
          <mat-label>País de Nacionalidad</mat-label>
          <input matInput placeholder="País de Nacionalidad" formControlName="paisNacionalidad">
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Estado Civil</mat-label>
          <mat-select placeholder="Estado Civil" formControlName="tipoEstadoCivil" (valueChange)="tipoEstadoCivilChange($event)">
            <mat-option *ngFor="let tipo of getTipoEstadoCivilKeys() " [value]="tipo">{{ tipoEstadoCivil[tipo] }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Régimen Patrimonial</mat-label>
          <mat-select placeholder="Régimen Patrimonial" formControlName="tipoRegimenPatrimonial" required>
            <mat-option *ngFor="let tipo of getTipoMatrimonioUnionCivilKeys() " [value]="tipo">{{ tipoMatrimonioUnionCivil[tipo] }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Sexo</mat-label>
          <mat-select placeholder="Tipo de Sexo" formControlName="tipoSexo">
            <mat-option *ngFor="let tipo of getTipoSexoKeys() " [value]="tipo">{{ tipoSexo[tipo] }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Vivienda</mat-label>
          <mat-select placeholder="Vivienda" formControlName="tipoVivienda" (valueChange)="tipoViviendaChange($event)">
            <mat-option *ngFor="let tipo of getTipoViviendaKeys() " [value]="tipo">{{ tipoVivienda[tipo] }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Otro Tipo de Vivienda</mat-label>
          <input matInput placeholder="Otro Tipo de Vivienda" formControlName="otroTipoVivienda">
        </mat-form-field>
      </div>
  
      <div class="form-group col-md-3">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Monto Arriendo</mat-label>
          <input matInput placeholder="$" currencyMask type="text" formControlName="montoArriendo">
        </mat-form-field>
      </div>
      
      <div class="row">
        <div class="mt-4">
          <button id="identificacionSiguienteBtn" type="button" (click)="onSubmit()" class="ml1 mr1 fr" mat-raised-button color="primary">Siguiente</button>
        </div>
      </div>
    </form>
  </div>